import React from 'react'
import ReactDOMServer from 'react-dom/server'
import tw from 'tailwind-styled-components'
import {Avatar} from '@components/avatar'
import {Highlight} from '@components/common/highlight/highlight'
import {TableUserInfo} from '@components/common/users-table/users-table'
import {highlightFromVariants} from './util'

const TwUserNameCol = tw.div`
  ck-reset_all-excluded
  px-4
  overflow-hidden
  shrink-0
  flex
  flex-grow
  items-baseline
`

const TwUserName = tw.div`
  whitespace-nowrap
  text-ellipsis
  overflow-hidden
  text-secondary-old
  text-11
  ml-4
`

const TwDepartmentsCol = tw.div`
  px-4
  overflow-hidden
`

const TwDepartments = tw.div`
  whitespace-nowrap
  text-ellipsis
  overflow-hidden
  text-third-old
  text-11
`

interface MentionListItemContentProps {
  item: TableUserInfo
  vars: string[] | undefined
}

const MentionListItemContent = ({item, vars}: MentionListItemContentProps) => (
  <>
    <TwUserNameCol style={{width: '130px'}}>
      <Avatar className="shrink-0 cursor-pointer" size={20} {...item} />
      <TwUserName>
        <Highlight
          text={item.userName}
          highlight={highlightFromVariants(item.userName, vars)}
        />
      </TwUserName>
    </TwUserNameCol>
    <TwDepartmentsCol style={{width: '90px'}}>
      <TwDepartments>
        <Highlight
          text={item.departments}
          highlight={highlightFromVariants(item.departments, vars)}
        />
      </TwDepartments>
    </TwDepartmentsCol>
  </>
)

export const renderMentionListItem = (
  item: TableUserInfo,
  vars: string[] | undefined,
  mentionClass?: string
): HTMLElement => {
  const el = document.createElement('div')
  if (mentionClass) {
    el.classList.add(mentionClass)
  }
  el.classList.add(
    'editor-mention-list-item',

    // prevents CKEditor reset styles from influencing everything below
    'ck-reset_all-excluded',

    'flex',
    'flex-row',
    'cursor-pointer',
    'hover:bg-chat-list-hover-old',
    'group',
    'leading-none',
    'overflow-hidden',
    'odd:bg-main-even-old',

    'px-4',
    'h-32',
    'text-secondary-old',
    'items-center'
  )

  el.innerHTML = ReactDOMServer.renderToString(
    <MentionListItemContent item={item} vars={vars} />
  )

  return el
}
